import React from 'react';
import "./UgTopSection.css";
import { IoLogoFacebook } from "react-icons/io5";
import { FaTelegram } from "react-icons/fa";

// Reusable component for displaying user information
function UserInfo({ userImage, userName }) {
  return (
    <div className='written'>
      <div className='written-Img'>
        <img src={userImage} alt='...' className='userimg'/>
      </div>
      <div className='written-heading ms-3 pt-2'>
        <h5 className='fs-6 text-white'>Written By</h5>
        <h3 className='fs-5 fw-bold text-white'>{userName}</h3>
      </div>
    </div>
  );
}

// Reusable component for the Ug Top section
function UgTopSection({ academyName, userImage, userName, Image }) {
  return (
      <div className='ugTop-container'> 
        <div className='ugTop-left'>
          <h1 className='fs-2 py-3 text-white'>{academyName}</h1>
          <UserInfo userImage={userImage} userName={userName} />
        </div>
        <div className='ugTop-right'>
          <img src={Image} alt='...' className='ugTop-img'/>
          <div className='text-center text-white phone-view-follow'>
            <h5 className='fs-6'>Follow us:</h5>
            <IoLogoFacebook className='fs-4 m-1' />
            <FaTelegram className='fs-4 m-1' />
          </div>
        </div>
      </div>
  );
}

export default UgTopSection;
